import { styled, Box, Slider, OutlinedInput } from '@mui/material';

export const BpmSliderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const BpmSlider = styled(Slider)(({ theme }) => ({
  flex: 1,
  '& .MuiSlider-thumb': {
    color: theme.palette.grey[50],
  },
  '& .MuiSlider-track': {
    color: theme.palette.grey[50],
  },
  '& .MuiSlider-rail': {
    color: theme.palette.grey[600],
  },
}));

export const BpmInput = styled(OutlinedInput)(() => ({
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& input::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '& input::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '&.MuiOutlinedInput-root': {
    borderRadius: 4,
  },
}));
